import { Component, OnInit } from '@angular/core';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
 scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/main.js'
  ];
  constructor( private scriptLoader: ScriptLoaderService,) { }

  ngOnInit(): void {
      this.scriptLoader.loadScripts(this.scripts);
  }
  contact = {
    subject: 'Service client',
    email: '',
    message: '',
    file: null
  };

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.contact.file = file;
      console.log('Fichier sélectionné :', file.name);
    }
  }

  onSubmit() {
    console.log('Formulaire soumis :', this.contact);
    // Implémentez la logique pour envoyer les données au serveur ici.
    alert('Votre message a été envoyé avec succès !');
  }
}
